import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Container from './Container';
// import { Modal } from "react-bootstrap"
import { Link } from 'gatsby';
import SocialList from './SocialList';

// import SocilaList from "../ContactUs/socialList"
// import ContactUs from "../ContactUs/contactUs"

const FooterNew = () => {
  return (
    <div className="footer">
      <Container>
        <Grid container className="footer-top-row">
          <Grid item sm={4} xs={12}>
            <div className="address-wrapper">
              <h6 className="heading">Singapore</h6>
              <p>
                68, Circular Road, <br /> #02-01,049422,
                <br />
                Singapore
              </p>
            </div>
          </Grid>
          <Grid item sm={4} xs={12}>
            <div className="address-wrapper">
              <h6 className="heading">Australia</h6>
              <p>
                Level 2 23 Foster Street, <br />
                Surry Hills NSW 2010, <br /> Australia
              </p>
            </div>
          </Grid>
          <Grid item sm={4} xs={12}>
            <div className="address-wrapper">
              <h6 className="heading">Sri Lanka</h6>
              <p>
                292, High Level Rd, <br />
                Nugegoda 10250,
                <br />
                Sri Lanka
              </p>
            </div>
          </Grid>
        </Grid>
      </Container>
      <hr />
      <Container>
        <Grid container className="footer-bottom-row">
          <Grid item sm={6} xs={12} className="left-col">
            <SocialList />
            <div className="privacy-wrapper small-font">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </div>
          </Grid>
          <Grid item sm={6} xs={12} className="right-col">
            <p className="small-font">
              &copy; 2017 - {new Date().getFullYear()} Meetrix Pte. Ltd
            </p>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default FooterNew;
